import { features } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
              平台优势
            </span>
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">
              为什么选择蓝莓影院
            </h2>
            <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
              五大核心优势，打造极致观影体验
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {features.slice(0, 3).map((feature) => (
              <article
                key={feature.id}
                className="bg-background-100 rounded-xl p-6 border border-background-200/70"
              >
                <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-xl text-primary-600`}></i>
                </div>
                <h3 className="text-base font-bold text-foreground-900 mb-2">{feature.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
              </article>
            ))}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5 max-w-2xl mx-auto">
            {features.slice(3).map((feature) => (
              <article
                key={feature.id}
                className="bg-background-100 rounded-xl p-6 border border-background-200/70"
              >
                <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-xl text-accent-600`}></i>
                </div>
                <h3 className="text-base font-bold text-foreground-900 mb-2">{feature.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}